import TokenService from '@/services/storage.service'
import axios from 'axios'

export const LOGIN_PATH = '/login'

const PUBLIC_PATHS = [LOGIN_PATH, '/maintenance', '/', '/access-denied']

let isHandlingSessionExpiry = false

export function clearAuthSession() {
  TokenService.removeToken()
  TokenService.removeRefreshToken()
  TokenService.removeUser()
  TokenService.removeUserHashId()
  TokenService.removeTyreStatus()

  delete axios.defaults.headers.common.Authorization
  delete axios.defaults.headers.common['Content-Type']

  sessionStorage.removeItem('permissions')
  sessionStorage.removeItem('user_id')
  sessionStorage.removeItem('menu')
  sessionStorage.removeItem('footer')
  sessionStorage.removeItem('sliders')
  sessionStorage.removeItem('main_boxes')
  sessionStorage.removeItem('groups')
  sessionStorage.removeItem('percentage')

  localStorage.removeItem('tenantPermissions')
  localStorage.removeItem('tenantModuleConfigs')

  import('@/store').then(({ default: store }) => {
    store.commit('CLEAR_AUTH_SESSION')
  })
}

export function isSessionExpiredResponse(error) {
  const status = error?.response?.status
  return status === 401 || status === 419
}

export function isUnauthorizedMeResponse(response) {
  return response?.status === 401 || response?.status === 419
}

export function abortNavigationToLogin(next, redirectFrom = null) {
  clearAuthSession()

  next({
    name: 'login',
    query: redirectFrom ? { redirect: redirectFrom } : {},
    replace: true
  })
}

export function forceLogoutToLogin(options = {}) {
  const { redirect = true } = options

  if (isHandlingSessionExpiry) {
    return
  }

  isHandlingSessionExpiry = true
  clearAuthSession()

  if (!redirect) {
    isHandlingSessionExpiry = false
    return
  }

  import('@/router')
    .then((module) => {
      const router = module.default
      const currentPath = router.currentRoute.value.path
      const shouldPreserveRedirect = !PUBLIC_PATHS.includes(currentPath)

      return router.push({
        name: 'login',
        query: shouldPreserveRedirect ? { redirect: router.currentRoute.value.fullPath } : {},
        replace: true
      })
    })
    .finally(() => {
      isHandlingSessionExpiry = false
    })
}

export { PUBLIC_PATHS }
